import React, { Component } from 'react';
import { connect } from 'react-redux';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import Messages from '../../../shared/UI/Messages/Messages';
import { HASACCESS } from '../../../shared/utility';
import { Companyid, DATATABLE_CONFIG, USER_SUBMENU_ID } from '../../../shared/Config';
import * as actions from '../../../store/actions/index';

// Real backend channel GUIDs (see POS/Layout/POSSidebar.js ORDER_TYPES).
// The sold-out record's `orderTypes` field holds one or more of these,
// comma-separated, e.g. "<dineIn>,<takeAway>" when both are sold out.
const CHANNEL_IDS = {
    dineIn: '550e8400-e29b-41d4-a716-446655440001',
    takeAway: '550e8400-e29b-41d4-a716-446655440002',
    delivery: '550e8400-e29b-41d4-a716-446655440003'
};

const parseOrderTypes = (orderTypes) => {
    const ids = (orderTypes || '').split(',').map(id => id.trim()).filter(Boolean);
    return {
        dineIn: ids.includes(CHANNEL_IDS.dineIn),
        takeAway: ids.includes(CHANNEL_IDS.takeAway),
        delivery: ids.includes(CHANNEL_IDS.delivery)
    };
};

const buildOrderTypes = (channels) => {
    return [
        channels.dineIn && CHANNEL_IDS.dineIn,
        channels.takeAway && CHANNEL_IDS.takeAway,
        channels.delivery && CHANNEL_IDS.delivery
    ].filter(Boolean).join(',');
};


class Soldout extends Component {

    state = {
        CompanyId: this.props.loggedUserDetail.CompanyId,
        Createdby: (this.props.loggedUserDetail.empID) ?? '',
        Createddate: new Date(),
        globalFilter: '',
        channelMap: {}
    }

    componentDidMount() {
        this.getAccess = HASACCESS(USER_SUBMENU_ID);
        this.props.getMasterKeywordList('Branch');
        this.props.getMasterKeywordList('MenuItem');
        this.props.getMasterTableList('res/GetmenuitemsoldoutList', Companyid);
    }

    componentDidUpdate(prevProps) {
        if (this.props.tableLists !== prevProps.tableLists && this.props.tableLists && this.props.tableLists.length > 0) {
            // Only seed rows we haven't seen yet, so a save can't get reverted
            // by a list refresh that lags behind the save itself.
            this.setState(prev => {
                const channelMap = { ...prev.channelMap };
                this.props.tableLists.forEach(item => {
                    if (!channelMap[item.menuItemSoldOutId]) {
                        channelMap[item.menuItemSoldOutId] = parseOrderTypes(item.orderTypes);
                    }
                });
                return { channelMap };
            });
        }
    }

    lookupLabel = (list, value) => {
        if (!value) { return ''; }
        let match = (list || []).find(item => item.value === value);
        return match ? match.label : value;
    }

    toggleChannel = (menuItemSoldOutId, channel, checked) => {
        this.setState(prev => ({
            channelMap: {
                ...prev.channelMap,
                [menuItemSoldOutId]: { ...prev.channelMap[menuItemSoldOutId], [channel]: checked }
            }
        }));
    }

    saveRow = (rowData) => {
        const channels = this.state.channelMap[rowData.menuItemSoldOutId] || {};
        const orderTypes = buildOrderTypes(channels);

        const data = {
            menuItemSoldOutId: rowData.menuItemSoldOutId,
            companyId: this.state.CompanyId,
            outletId: rowData.outletId,
            menuItemId: rowData.menuItemId,
            channelId: rowData.channelId || null,
            orderTypes: orderTypes || null,
            availabilityDate: rowData.availabilityDate,
            startTime: rowData.startTime,
            endTime: rowData.endTime,
            status: orderTypes ? 'SOLDOUT' : 'AVAILABLE',
            availableQty: (rowData.availableQty !== null && rowData.availableQty !== undefined) ? rowData.availableQty : null,
            soldQty: (rowData.soldQty !== null && rowData.soldQty !== undefined) ? rowData.soldQty : null,
            reasonCode: rowData.reasonCode || null,
            remarks: rowData.remarks || null,
            source: rowData.source,
            autoSoldOut: rowData.autoSoldOut === true,
            isOverride: rowData.isOverride === true,
            overrideQty: (rowData.overrideQty !== null && rowData.overrideQty !== undefined) ? rowData.overrideQty : null,
            createdBy: this.state.Createdby,
            createdDate: this.state.Createddate
        };

        this.props.processDynamicData('Menuitemsoldout', 'edit', data, 'res/GetmenuitemsoldoutList?companyId=' + Companyid);
    }

    // outletRender = (rowData) => (
    //     <React.Fragment>
    //         <span className="soldout-mobile-label">Outlet</span>
    //         <span className="soldout-mobile-value">{this.lookupLabel(this.props.Branch, rowData.outletId)}</span>
    //     </React.Fragment>
    // );

    menuItemRender = (rowData) => (
        <React.Fragment>
            <span className="soldout-mobile-label">Menu Item</span>
            <span className="soldout-mobile-value">{this.lookupLabel(this.props.MenuItem, rowData.menuItemId)}</span>
        </React.Fragment>
    );

    sourceRender = (rowData) => (
        <React.Fragment>
            <span className="soldout-mobile-label">Source</span>
            <span className="soldout-mobile-value">{rowData.source}</span>
        </React.Fragment>
    );

    channelToggleBody = (rowData, channel, label) => {
        const checked = !!(this.state.channelMap[rowData.menuItemSoldOutId] || {})[channel];
        return (
            <React.Fragment>
                <span className="soldout-mobile-label">{label}</span>
                <span className="soldout-mobile-value">
                    <button
                        type="button"
                        className={'soldout-x-toggle' + (checked ? ' is-checked' : '')}
                        aria-pressed={checked}
                        aria-label={label + (checked ? ' sold out' : ' available')}
                        onClick={() => this.toggleChannel(rowData.menuItemSoldOutId, channel, !checked)}
                    >
                        <i className="pi pi-times"></i>
                    </button>
                </span>
            </React.Fragment>
        );
    };

    dineInBody = (rowData) => this.channelToggleBody(rowData, 'dineIn', 'Dine In');

    takeAwayBody = (rowData) => this.channelToggleBody(rowData, 'takeAway', 'Take Away');

    deliveryBody = (rowData) => this.channelToggleBody(rowData, 'delivery', 'Delivery');

    saveBody = (rowData) => (
        <React.Fragment>
            <span className="soldout-mobile-label"></span>
            <span className="soldout-mobile-value">
                <Button label="Save" icon="pi pi-save" className="p-button-sm soldout-save-btn" onClick={() => this.saveRow(rowData)} />
            </span>
        </React.Fragment>
    );

    render() {

        if (this.getAccess !== undefined && this.getAccess.viewAccess === false) {
            this.props.history.push('/dashboard');
        }

        let tableData = [];
        if (this.props.tableLists && this.props.tableLists.length > 0) {
            tableData = this.props.tableLists;
        }

        const { globalFilter } = this.state;

        const header = (
            <div className="soldout-header">
                <span className="p-input-icon-left soldout-search">
                    <i className="pi pi-search"></i>
                    <InputText
                        type="search"
                        onInput={(e) => this.setState({ globalFilter: e.target.value })}
                        placeholder="Search menu items..."
                    />
                </span>
            </div>
        );

        return (
            <div className="p-grid padding soldout-page">
                {this.props.loading && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                {this.props.success !== null && <Messages type="success" message={this.props.success} />}

                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <div className="soldout-page-header">
                            {/* <div className="soldout-page-icon">
                                <i className="pi pi-ban"></i>
                            </div> */}
                            <div className="soldout-page-heading">
                                <h1>Sold Out</h1>
                                <p className="soldout-page-subtitle">Control item availability across Dine In, Take Away and Delivery</p>
                            </div>
                            {tableData.length > 0 &&
                                <span className="soldout-count-badge">{tableData.length} item{tableData.length !== 1 ? 's' : ''}</span>
                            }
                        </div>

                        <DataTable
                            value={tableData}
                            globalFilter={globalFilter}
                            header={header}
                            {...DATATABLE_CONFIG}
                        >
                            {/* <Column body={this.outletRender} header="Outlet" /> */}
                            <Column body={this.menuItemRender} header="Menu Item" />
                            <Column field="source" body={this.sourceRender} header="Source" />
                            <Column body={this.dineInBody} header={<span className="soldout-col-head"><i className="pi pi-home"></i>Dine In</span>} bodyClassName="soldout-checkbox-col" headerClassName="soldout-checkbox-col" />
                            <Column body={this.takeAwayBody} header={<span className="soldout-col-head"><i className="pi pi-shopping-cart"></i>Take Away</span>} bodyClassName="soldout-checkbox-col" headerClassName="soldout-checkbox-col" />
                            <Column body={this.deliveryBody} header={<span className="soldout-col-head"><i className="pi pi-directions-alt"></i>Delivery</span>} bodyClassName="soldout-checkbox-col" headerClassName="soldout-checkbox-col" />
                            <Column body={this.saveBody} header="Action" />
                        </DataTable>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        loggedUserDetail: state.auth.userObject,
        loading: state.master.loading,
        error: state.master.error,
        success: state.master.success,
        tableLists: state.master.tableLists,
        Branch: (state.keyword.Branch !== undefined) ? state.keyword.Branch : [],
        MenuItem: (state.keyword.MenuItem !== undefined) ? state.keyword.MenuItem : [],
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getMasterTableList: (table, company) => dispatch(actions.getMasterTableList(table, company)),
        getMasterKeywordList: (value) => dispatch(actions.getMasterKeywordList(value)),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Soldout);
